import { SalesPackDespatchItemReport } from './sales-pack-despatch-item-report';
import { SellingCompanyReport } from '../../../../tms-shared';

export interface SalesPackReport {
  id: string;
  packNo: number;
  customerKey: string;
  customerName: string;
  customerAddressMultiLine: string;
  grossQuantity: number;
  nettQuantity: number;
  tareKgs: number;
  height: number;
  width: number;
  depth: number;
  volume: number;
  packTypeKey: string;
  packTypeDescription: string;
  shippingPackKey: string;
  shippingPackDescription: string;
  datePacked: Date;
  packedBy: string;
  notes: string;
  customerPackNo: string;
  despatchNoteNo: number;
  despatchDate: Date;
  deliveryAddressMultiLine: string;
  shipperSupplier: string;
  orderedBy: string;
  trackingNo: string;
  noOfItems: number;
  printDeliveryAddress: boolean;

  sellingCompany: SellingCompanyReport;
  salesDespatchItems: SalesPackDespatchItemReport[];
}
